import { useClientStore } from '@/stores/ClientStore'
import { get as _get } from 'lodash'

export function useAllowedFeatures () {
  const { getClient } = useClientStore()

  const { client } = getClient()

  const allowedSportingActivitiesProvider = provider => providers === true || Array.isArray(providers) && providers.includes(provider)

  const providers = _get(client.value, 'allowed_features.sporting_activities.providers', false)
  const allowedPayconiq = !!_get(client.value, 'integrations.payconiq.payment_profile_id', false)
  const allowedSportingActivities = allowedSportingActivitiesProvider('manual') || (_get(client.value, 'integrations.strava.client_id', false) && allowedSportingActivitiesProvider('strava'))
  const allowedAccountVerification = _get(client.value, 'allowed_features.account_verification', false)
  const allowedRecaptcha = _get(client.value, 'allowed_features.recaptcha', false)
  const allowedAuthenticationForm = _get(client.value, 'allowed_features.authentication.visibility', ['platform']).includes('platform')
  const allowedConsentManagementPlatform = _get(client.value, 'allowed_features.consent_management_platform', false) && client.value.has_consent_management_platform

  return {
    allowedAccountVerification,
    allowedPayconiq,
    allowedSportingActivities,
    allowedAuthenticationForm,
    allowedRecaptcha,
    allowedConsentManagementPlatform,
    allowedSportingActivitiesProvider
  }
}